import React, { Component, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { getUsers, editUser, createUser, adminResetPassword } from "../../actions/authAction";
import setAuthorizationToken from "../../utils/setAuthorizationToken"
import PropTypes from "prop-types";
import { Grid, GridColumn, Menu, Icon, Table, Popup } from "semantic-ui-react";

import SearchUsers from "./SearchUsers";
import {
  SyledContainer,
  StyledGridRow,
  StyledTable,
  ActiveInd,
  SuperScript,
  ToolTip,
} from "../common/StyledComponents";
import Spinner from "../common/Spinner";
import AddOrEditModal from "./AddOrEditModal";
import DeleteUserModal from "./DeleteUserModal";
import AdminResetPasswordModal from "./AdminResetPasswordModal";
import SuccessNotifyModal from "./SuccessNotifyModal";

function chunkArray(myArray, chunk_size = 10) {
  const arrayLength = myArray.length;
  const tempArray = [];
  for (let index = 0; index < arrayLength; index += chunk_size) {
    const myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }

  return tempArray;
}

const filteredResultsList = (users, query) => {
  if (users && query) {
    let filteredData = users;
    for (let key in query) {
      // console.log(key);
      if (query[key] !== undefined || query[key] !== null) {
        filteredData = filteredData.filter((d) => {
          if (key === "firstName") {
            const _qry = `${d.firstName} ${d.lastName}`;
            return _qry.toLowerCase().includes(query[key].toLowerCase());
          }
          if (key === "roleType") {
            return d.roles.indexOf(query[key]) > -1;
          }
          if (key === "branchName") {
            return d.branches.indexOf(query[key]) > -1;
          }
          if (key === "statusType") {
            return query[key] === "Active" ? d.active : !d.active; //d.branches.indexOf(query[key]) > -1;
          }
        });
      }
    }
    return filteredData;
  }
};

export const UserListTable = (props) => {
  const { users } = props;
  const [pageId, setPageId] = useState(0);
  let _searchList = chunkArray(users, 5);

  const [resultList, setResultList] = useState(_searchList[pageId]);

  const navigateToPage = (pageNumber) => {
    setPageId(pageNumber);
    setResultList(_searchList[pageNumber]);
  };

  if (!!resultList && resultList.length) {
    return (
      <Grid.Row width={16}>
        <GridColumn style={{ padding: 0 }}>
          <StyledTable basic singleline="true" className="editable">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>User</Table.HeaderCell>
                <Table.HeaderCell className="type">Type</Table.HeaderCell>
                <Table.HeaderCell className="status">Status</Table.HeaderCell>
                <Table.HeaderCell>Branch</Table.HeaderCell>
                <Table.HeaderCell>ResetPassword</Table.HeaderCell>
                <Table.HeaderCell>Delete</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {resultList.map((r, i) => {
                return (
                  <Table.Row
                    className={i % 2 === 0 ? "bg-lightGrey" : ""}
                    onClick={(e) => props.openEditModal(e, r)}
                    key={r.dateOfBirth + i}
                  >
                    <Table.Cell className="firstCol">
                      {r.firstName} {r.lastName}
                      {r.admin && <SuperScript>Admin</SuperScript>}
                    </Table.Cell>
                    <Table.Cell className="type">
                      {r.roles[0]}
                      {r.roles.length > 1 && `(+ ${r.roles.length - 1})`}
                    </Table.Cell>
                    <Table.Cell className="status">
                      <ActiveInd active={r.active}>
                        {r.active ? "Active" : "Inactive"}
                      </ActiveInd>
                    </Table.Cell>
                    <Table.Cell>
                      {r.branches[0]}
                      {r.branches.length > 1 && (
                        <Popup
                          trigger={
                            <SuperScript>+{r.branches.length - 1}</SuperScript>
                          }
                        >
                          <Popup.Content>
                            <ToolTip>
                              <span>
                                {r.branches.map((b, id) => {
                                  return id < 4 && <i key={b}>{b}</i>;
                                })}
                                {r.branches.length > 4 && ", ..."}
                              </span>
                            </ToolTip>
                          </Popup.Content>
                        </Popup>
                      )}
                    </Table.Cell>
                    <Table.Cell id="reset">
                      <Icon id="reset" name="lock" size='small' aria-label='Reset Password' />
                    </Table.Cell>
                    <Table.Cell className="lastCol" id="trash">
                      <Icon
                        color="red"
                        name="trash alternate outline"
                        id="trash"
                      />
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>

            {_searchList.length > 1 && (
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="16">
                    <Menu floated="right" pagination>
                      <Menu.Item
                        as="a"
                        icon
                        disabled={pageId === 0}
                        onClick={() => navigateToPage(pageId - 1)}
                      >
                        <Icon name="chevron left" />
                      </Menu.Item>
                      {_searchList.map((l, i) => {
                        return (
                          <Menu.Item
                            key={`page-${i + 1}`}
                            as="a"
                            onClick={() => navigateToPage(i)}
                          >
                            {i + 1}
                          </Menu.Item>
                        );
                      })}
                      <Menu.Item
                        as="a"
                        icon
                        disabled={pageId + 1 === _searchList.length}
                        onClick={() => navigateToPage(pageId + 1)}
                      >
                        <Icon name="chevron right" />
                      </Menu.Item>
                    </Menu>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            )}
          </StyledTable>
        </GridColumn>
      </Grid.Row>
    );
  }
  return null;
};

class UserList extends Component {
  constructor(props) {
    super(props);
    props.getUsers();
    this.state = {
      searchList: [],
      filteredList: null,
      id: 1,
      searchQuery: null,
      resultList: null,
      stateLoad: false,
      openDeleteModal: false,
      resetPasswordModal: false,
      showConfirmModal: false,
      flow: null,
    };
  }

  // componentDidMount() {
  //   document.body.classList.remove("boorstrap-pre");
  //   document.getElementById("navBar").classList.add("boorstrap-pre");
  // }

  static getDerivedStateFromProps(props, state) {
    // const { users } = props.auth;
    if (props?.auth?.users && !state.searchQuery) {
      const searchList = props?.auth?.users;

      return { searchList };
    }
  }

  onSearchClick = (obj) => {
    const { searchList } = this.state;
    this.setState({ stateLoad: true });
    const _resultList = filteredResultsList(searchList, obj);
    setTimeout(() => {
      this.setState({
        searchQuery: obj,
        resultList: _resultList,
        stateLoad: false,
      });
    }, 500);
  };

  openEditModal = (e, obj = null) => {
    e.preventDefault();
    const { target } = e;
    if (target.id === "trash") {
      this.setState({
        openDeleteModal: true,
      });
    } else if (target.id === "reset") {
      this.setState({
        editdata: obj,
        resetPasswordModal: true,
      });
    }
    else {
      this.setState({
        editdata: obj,
        open: true,
      });
    }
  };

  closeModal = () => {
    this.setState({
      editdata: null,
      open: false,
    });
  };

  onSaveUser = (obj, _editUser) => {
    let _flow = null;
    if (!_editUser) {
      const editingUser = {};
      editingUser.gender = "M";
      editingUser.newUser = true;
      editingUser.dateOfBirth = "2019-10-27T19:22:12.633Z";
      editingUser.orgId = "" + localStorage.orgID;
      this.props.createUser(
        { ...obj, ...editingUser },
        this.props.history,
        true
      );
      _flow = "NEW_USER";
    } else {
      this.props.editUser(obj, this.props.history, true);
      _flow = "EDIT_USER";
    }
    this.setState({
      editdata: null,
      open: false,
      flow: _flow,
      showConfirmModal: true,
    });
  };

  deleteUser = (bool) => {
    let _flow = null;
    let _showConfirmModal = false;
    if (bool) {
      // trigger call for delete user
      _showConfirmModal = true;
      _flow = "DELETE_USER";
    }
    this.setState({
      openDeleteModal: false,
      showConfirmModal: _showConfirmModal,
      flow: _flow,
    });
  };

  resetPassword = (_editUser, bool) => {
    let _flow = null;
    let _showConfirmModal = false;

    if (_editUser && bool) {
      const userToReset = { userEmail: _editUser.emailAddress }
      this.props.adminResetPassword(
        userToReset,
        this.props.history,
        true
      );
      _showConfirmModal = true;
      _flow = "RESET_USER_PASSWORD";
    }

    this.setState({
      resetPasswordModal: false,
      showConfirmModal: _showConfirmModal,
      flow: _flow,
    });
  }

  onCloseSuccess = () => {
    this.setState({
      showConfirmModal: false,
      flow: null,
    });
    window.location.reload();
  };

  render() {
    const { auth } = this.props;
    const { loading } = auth;
    const {
      searchList,
      searchQuery,
      stateLoad,
      resultList,
      open,
      editdata,
      resetPasswordModal,
      openDeleteModal,
      showConfirmModal,
      flow,
    } = this.state;
    if (loading) {
      return <Spinner />;
    }
    const serchData = resultList ? resultList : searchList;
    return (
      <SyledContainer centered="true">
        <SearchUsers
          users={searchList}
          onSearchClick={this.onSearchClick}
          openAddUserModal={this.openEditModal}
        />
        <StyledGridRow padded="horizontally" className="noborder top4Em" >
          {!stateLoad && (
            <UserListTable
              key={`results{id}`}
              users={serchData}
              searchQuery={searchQuery}
              openEditModal={this.openEditModal}
            />
          )}
        </StyledGridRow>
        {open && (
          <AddOrEditModal
            openState={open}
            closeModal={this.closeModal}
            userData={editdata}
            isEditMode={editdata !== null}
            onSaveUser={this.onSaveUser}
            users={searchList}
          />
        )}
        {openDeleteModal && (
          <DeleteUserModal
            open={openDeleteModal}
            deleteUser={this.deleteUser}
          />
        )}
        {resetPasswordModal && (
          <AdminResetPasswordModal
            open={resetPasswordModal}
            userData={editdata}
            resetPassword={this.resetPassword}
          />
        )}
        {showConfirmModal && flow && (
          <SuccessNotifyModal
            open={showConfirmModal}
            flow={flow}
            closeModal={this.onCloseSuccess}
          />
        )}
      </SyledContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getUsers, editUser, createUser, adminResetPassword })(
  UserList
);

// export default UserList;
